import React, { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { tableStatusColors } from "constant"
import classes from "./TdBoxMovable.module.scss"

const tableSizes = {
  small: 25,
  medium: 35,
  large: 45
}

const TdBoxMovable = props => {
  const { table, setTables } = props

  const i18n = useTranslation()[1]

  const [isDragging, setIsDragging] = useState(false)
  const [boxPosition, setBoxPosition] = useState({ x: 0, y: 0 })

  const shift = useRef({ x: 0, y: 0 })
  const tableRef = useRef(null)

  const handleMouseUp =
    useCallback(() => {
      setIsDragging(false)

      const containerWidth =
        document.getElementById("tables-container").offsetWidth

      const containerHeight =
        document.getElementById("tables-container").offsetHeight

      const tableOffsetRight =
        tableRef.current.offsetLeft +
        tableRef.current.offsetWidth -
        containerWidth

      setTables(prev =>
        prev.map(t =>
          t.tableNumber === table.tableNumber
            ?
            {
              ...t,
              position: {
                x: tableOffsetRight / containerWidth,
                y: tableRef.current.offsetTop / containerHeight
              }
            }
            :
            t
        )
      )

      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("touchmove", handleMouseMove)
      window.removeEventListener("touchend", handleMouseUp)
    }, [])

  const handleMouseMove =
    useCallback((event) => {
      const cursorXPosition =
        event.clientX ||
        event.touches[0].clientX

      const cursorYPosition =
        event.clientY ||
        event.touches[0].clientY

      let x = -(cursorXPosition - shift.current.x)

      let y = cursorYPosition - shift.current.y

      if (y < 0) y = 0

      if (x < 0) x = 0

      setBoxPosition({ x, y })
    }, [])


  const handleMouseDown = (event) => {
    setIsDragging(true)

    const containerWidth =
      document.getElementById("tables-container").offsetWidth

    const tableOffsetRight =
      tableRef.current.offsetLeft +
      tableRef.current.offsetWidth -
      containerWidth

    const cursorXPosition =
      event.clientX ||
      event.touches[0].clientX

    const cursorYPosition =
      event.clientY ||
      event.touches[0].clientY

    shift.current.x =
      cursorXPosition - tableOffsetRight

    shift.current.y =
      cursorYPosition - tableRef.current.offsetTop

    window.addEventListener("mousemove", handleMouseMove)

    window.addEventListener("mouseup", handleMouseUp)

    window.addEventListener("touchmove", handleMouseMove)

    window.addEventListener("touchend", handleMouseUp)
  }

  const initialTablePosition = () => {
    const containerWidth =
      document.getElementById("tables-container").offsetWidth

    const containerHeight =
      document.getElementById("tables-container").offsetHeight

    setBoxPosition({
      x: -(table.position.x * containerWidth) | 0,
      y: (table.position.y * containerHeight) | 0
    })
  }

  const handleResize =
    useCallback(() => {
      initialTablePosition()
    }, [])

  useLayoutEffect(() => {
    initialTablePosition()
  }, [])

  useEffect(() => {
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
      window.removeEventListener("mousemove", handleMouseMove)
      window.removeEventListener("mouseup", handleMouseUp)
      window.removeEventListener("touchmove", handleMouseMove)
      window.removeEventListener("touchend", handleMouseUp)
    }
  }, [])

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div
      ref={tableRef}
      draggable={false}
      onMouseDown={handleMouseDown}
      onTouchStart={handleMouseDown}
      className={clsx(
        classes["box"],
        isLtr && classes["box-ltr"],
        isDragging && classes["dragging"],
        classes[table.shape]
      )}
      style={{
        width: tableSizes[table.scale],
        height: tableSizes[table.scale],
        borderColor: tableStatusColors[table.status],
        right: isLtr ? "unset" : `${boxPosition.x}px`,
        left: isLtr ? `${boxPosition.x}px` : "unset",
        top: `${boxPosition.y}px`,
        transform:
          table.shape === "diamond" ? "rotate(45deg)" : ""
      }}
    >
      <span
        className={classes["text"]}
        style={{
          transform:
            table.shape === "diamond" ? "rotate(-45deg)" : ""
        }}
      >
        {table.tableNumber}
      </span>
    </div>
  )
}

export default TdBoxMovable